( function () {
  // Helper function to update all cart counters
  function updateCartCounters ( count ) {
    const counters = [
      document.getElementById( 'cart-item-count' ),
      document.getElementById( 'cart-item-count-sticky' ),
      ...document.querySelectorAll( '.header-cart-icon__count' ),
      ...document.querySelectorAll( '[data-cart-count]' )
    ]

    counters.forEach( counter => {
      if ( counter ) {
        counter.textContent = count
      }
    } )
  }

  document.addEventListener( 'click', function ( e ) {
    const addToCartButton = e.target.closest( '[data-add-to-cart]' )
    if ( !addToCartButton ) return

    const form = addToCartButton.closest( 'form' )
    if ( !form ) return

    e.preventDefault()
    addToCartButton.disabled = true

    const formData = new FormData( form )

    fetch( '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify( Object.fromEntries( formData ) )
    } )
      .then( response => response.json() )
      .then( data => fetch( '/cart.js?t=' + Date.now() ) )
      .then( response => response.json() )
      .then( cart => {
        updateCartCounters( cart.item_count )
      } )
      .catch( error => {
        console.error( 'Error:', error )
      } )
      .finally( () => {
        addToCartButton.disabled = false
      } )
  } )

  // Intercept fetch requests
  const originalFetch = window.fetch
  window.fetch = function ( url, options ) {
    const promise = originalFetch.apply( this, arguments )

    if ( typeof url === 'string' && (
      url.includes( '/cart/update.js' ) ||
      url.includes( '/cart/change.js' ) ||
      url.includes( '/cart/add.js' ) ||
      url.includes( '/cart/update' ) ||
      url.includes( '/cart/change' )
    ) ) {
      promise.then( () => {
        setTimeout( () => {
          fetch( '/cart.js' )
            .then( res => res.json() )
            .then( cart => {
              updateCartCounters( cart.item_count )
            } )
        }, 100 )
      } )
    }
    return promise
  }

  // Intercept XHR requests
  const originalXHR = window.XMLHttpRequest.prototype.send
  window.XMLHttpRequest.prototype.send = function () {
    this.addEventListener( 'load', function () {
      if ( this._url && (
        this._url.includes( '/cart/update.js' ) ||
        this._url.includes( '/cart/change.js' ) ||
        this._url.includes( '/cart/add.js' ) ||
        this._url.includes( '/cart/update' ) ||
        this._url.includes( '/cart/change' )
      ) ) {
        setTimeout( () => {
          fetch( '/cart.js' )
            .then( res => res.json() )
            .then( cart => {
              updateCartCounters( cart.item_count )
            } )
        }, 100 )
      }
    } )

    originalXHR.apply( this, arguments )
  }
} )()